import React from "react"

import "./style.css"

// One tag element
const FilterTag = ({ checked, onClick, children }) => {
    // onClick can be undefined.
    // That means it should not be viewd as a checkbox
    const onEnter = (e) => e.keyCode === 13 && onClick()

    return (
        <div onClick={onClick} onKeyDown={onEnter} className="filter-tag button button--gray" tabIndex="0">
            { checked !== undefined && <div className={`filter-tag__checkbox ${checked && "filter-tag__checkbox--checked"}`} /> }
            { children }
        </div>
    )
}

export default FilterTag



// WEBPACK FOOTER //
// ./src/components/FilterTag/index.js